export default function Avatar({ name, size = 32 }) {
  const init = (name || '')
    .split(' ')
    .map((s) => s[0])
    .filter(Boolean)
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <div className="avatar" style={{ width: size, height: size, fontSize: size * 0.42 }}>
      {init}
    </div>
  );
}
